<template>
  <div>
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog" :visible="tableMark" width="930px" center >
      <el-tabs v-model="activeName"  @tab-click="handleTabClick" >
        <el-tab-pane label="表头设置" name="biaotou">
        </el-tab-pane>
        <el-tab-pane label="导出设置" name="daochu"> </el-tab-pane>
      </el-tabs>
      <div style="display:flex;justify-content: space-around;height:610px">
        <div>
          <el-table :data="tableList" ref="tableList" v-loading="loading" @select='selectGoods' @selection-change="handleSelectionChange" @row-click="rowClick"
          :row-style="rowStyle" :row-class-name="rowClassName" v-if="bgFlag" @select-all="quanxuan($event)" center border height="600">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column type="index" width="55" label="序号"></el-table-column>
            <el-table-column property="cnName" label="设置字段" width="180"></el-table-column>
          </el-table>
        </div>
        <el-table :data="settingData" ref="settingDataRef" v-loading="loading1" v-if="bgFlag" center border row-key="id" height="600" style="margin-left:30px;">
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <el-table-column label="移动" width="60">
          <template slot-scope="scope">
            <el-button type="text" size="mini" class="move" >
              <i class="fa fa-arrows-alt" aria-hidden="true"></i>
            </el-button>
          </template>
        </el-table-column>
          <el-table-column type="index" width="55" label="操作">
            <template scope="scope">
              <el-button type="text" @click="quxiao(scope.row,scope.$index)">取消</el-button>
            </template >
          </el-table-column>
          <el-table-column property="cnName" label="展示字段"></el-table-column>
          <el-table-column label="是否支持查询" width="130" v-if="activeName=='biaotou'">
            <template scope="scope">
              <el-radio-group v-if="scope.row.isCodeQuery != '0'" v-model="scope.row.isSettingQuery">
                <el-radio :label="0">否</el-radio>
                <el-radio :label="1">是</el-radio>
              </el-radio-group>
            </template >
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from 'sortablejs'
import { queryAllSettingFiles, queryYesSettingFiles, saveOrUpdateOrRemove, queryMyExportPageField, queryYesSettingExportFiles, saveOrUpdateOrRemoveExport } from '@/api/newTMS'
export default {
  name: 'tableheades',
  props: {
    // 缓存中记录每个页面的key
    groupCode: {
      type: String,
      default: null
    },
    tableMark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      activeName: 'biaotou',
      title: '设置字段',
      tableList: [],
      loading: false,
      loading1: false,
      settingData: [],
      multipleSelection: [],
      isXuanList: [],
      bgFlag: true
    }
  },
  mounted () {
    console.log(this.groupCode, 'this.groupCode')
    this.queryAllSettingFiles()
    setTimeout(() => {
      this.queryYesSettingFiles()
    }, 200)
    this.$nextTick(() => {
      this.initSortable()
    })
  },
  methods: {
    handleTabClick () {
      this.bgFlag = false
      this.tableList = []
      this.settingData = []
      if (this.activeName == 'biaotou') {
        this.queryAllSettingFiles()
        setTimeout(() => {
          this.queryYesSettingFiles()
          this.bgFlag = true
          this.$nextTick(() => {
            this.initSortable()
          })
        }, 200)
      } else if (this.activeName == 'daochu') {
        this.queryAllSettingFiles()
        setTimeout(() => {
          this.queryYesSettingFilesDC()
          this.bgFlag = true
          this.$nextTick(() => {
            this.initSortable()
          })
        }, 200)
      }
    },
    // 创建sortable实例
    initSortable () {
      let _this = this
      // 获取表格row的父节点
      // console.log(this.$refs.settingDataRef,'this.$refs.settingDataRef')
      const ele = this.$refs.settingDataRef.$el.querySelector(
        '.el-table__body > tbody'
      )

      // 创建拖拽实例
      let dragTable = Sortable.create(ele, {
        animation: 150, // 动画
        disabled: false, // 拖拽不可用? false 启用（刚刚渲染表格的时候起作用，后面不起作用）
        handle: '.move', // 指定拖拽目标，点击此目标才可拖拽元素(此例中设置操作按钮拖拽)
        filter: '.disabled', // 指定不可拖动的类名（el-table中可通过row-class-name设置行的class）
        dragClass: 'dragClass', // 设置拖拽样式类名
        ghostClass: 'ghostClass', // 设置拖拽停靠样式类名
        chosenClass: 'chosenClass', // 设置选中样式类名
        onUpdate: function (event) {
          var newIndex = event.newIndex
          var oldIndex = event.oldIndex
          var $li = ele.children[newIndex]
          var $oldLi = ele.children[oldIndex]
          ele.removeChild($li)
          // 再插入移动的节点到原有节点，还原了移动的操作
          if (newIndex > oldIndex) {
            ele.insertBefore($li, $oldLi)
          } else {
            ele.insertBefore($li, $oldLi.nextSibling)
          }
          // 更新items数组
          var item = _this.settingData.splice(oldIndex, 1)
          _this.settingData.splice(newIndex, 0, item[0])
        },
        // 开始拖动事件
        onStart: () => {
        },
        // 结束拖动事件
        onEnd: ({ newIndex, oldIndex }) => {
        }
      })
    },
    norepeat (arr) {
      var obj = {}// 声明一个空对象
      var newArr = []// 声明一个空数组，用来存放数组中去重后的值
      for (var i = 0; i < arr.length; i++) { // 遍历数组
        if (obj[arr[i]] == undefined) { // 如果对象中没有这个元素
          newArr.push(arr[i])// 空数组中加入这个元素
          obj[arr[i]] = 1// 对象这个元素赋值
        }
      }
      return newArr// 返回新数组的值
    },
    // 全选
    quanxuan (e) {
      // console.log(e,'e,index')
      if (e.length == 0) {
        this.isXuanList = []
        this.settingData = this.isXuanList
      } else {
        e.forEach(item => {
          let params = {
            tagCode: this.groupCode,
            cnName: item.cnName,
            enName: item.enName,
            dynamicFieldId: item.id,
            isCodeQuery: item.isCodeQuery,
            isSettingQuery: item.isCodeQuery == 1 ? 1 : 0
          }
          this.isXuanList.push(params)
        })
        this.norepeat(this.isXuanList)
        // console.log(this.isXuanList,'this.isXuanList')
        this.settingData = this.isXuanList
      }
    },
    // 表格选中事件
    handleSelectionChange (val) {
      this.multipleSelection = val
      // console.log(this.multipleSelection,'this.multipleSelection')
    },
    rowStyle ({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', { // 给每一行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex
      })
    },
    // 监听row-click事件，实现选中
    rowClick (row, column, event) {
      let refsElTable = this.$refs.tableList // 获取表格对象
      let findRow = this.multipleSelection.find(c => c.rowIndex == row.rowIndex) // 找到选中的行
      if (findRow) {
        refsElTable.toggleRowSelection(row, false) // 如过重复选中，则取消选中
      } else {
        refsElTable.toggleRowSelection(row, true) // 实现选中行中选中事件
      }
      let selectData = this.$refs.tableList.selection
      this.selectGoods(selectData, row)
    },
    // 实现选中高亮
    rowClassName ({ row, rowIndex }) {
      let rowName = ''
      let findRow = this.multipleSelection.find(c => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row'
      } else {
        rowName = ''
      }
      return rowName // 也可以再加上其他类名 如果有需求的话
    },
    selectGoods (list, item) {
      if (list.includes(item)) {
        // 勾选时做的事
        // console.log('成功', item)
        let params = {
          tagCode: this.groupCode,
          cnName: item.cnName,
          enName: item.enName,
          dynamicFieldId: item.id,
          isCodeQuery: item.isCodeQuery,
          isSettingQuery: item.isCodeQuery == 1 ? 1 : 0
        }
        // this.$set(item,'isDis',true)
        this.settingData.push(params)
        this.settingData = Array.from(new Set(this.settingData))
      } else {
        // 取消勾选时做的事，arguments[1]是当前取消勾选的项
        // console.log('取消', item)
        this.settingData.forEach((item, index) => {
          if (arguments[1].cnName == item.cnName) {
            this.settingData.splice(index, 1)
          }
        })
        // console.log('handleSelect', list.includes(item))
      }
    },
    quxiao (row, index) {
      console.log(row, 'row取消')
      this.settingData.splice(index, 1)
      this.tableList.forEach(item => {
        if (item.cnName == row.cnName) {
          this.$refs.tableList.toggleRowSelection(item, false)
        }
      })
    },
    // 查询要设置的字段表头
    queryAllSettingFiles () {
      this.loading = true
      queryAllSettingFiles({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        // groupReport 集团收支报表
        // companyReport 分子公司收支报表
        // deptReport 部门收支报表
        tagCode: this.groupCode
      }).then(res => {
        this.tableList = res
        this.loading = false
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 查询我的已设置字段表头
    queryYesSettingFiles () {
      this.loading1 = true
      queryYesSettingFiles({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.settingData = res
        this.settingData.forEach(val => {
          let json = this.tableList.filter(item => item.cnName == val.cnName)
          this.$refs.tableList.toggleRowSelection(json[0])
          // console.log(json,'json')
        })
        this.loading1 = false
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 新增或更新已设置字段表头
    saveOrUpdateOrRemove (list) {
      saveOrUpdateOrRemove(list).then(res => {
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('refresh')
        this.$emit('update:tableMark', false)
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 查询要设置的字段表头-导出
    queryAllSettingFilesDC () {
      queryMyExportPageField({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        // groupReport 集团收支报表
        // companyReport 分子公司收支报表
        // deptReport 部门收支报表
        tagCode: this.groupCode
      }).then(res => {
        this.tableList = res
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 查询我的已设置字段表头-导出
    queryYesSettingFilesDC () {
      this.loading1 = true
      queryYesSettingExportFiles({
        // 入参：tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        tagCode: this.groupCode
      }).then(res => {
        this.settingData = res
        this.settingData.forEach(val => {
          let json = this.tableList.filter(item => item.cnName == val.cnName)
          this.$refs.tableList.toggleRowSelection(json[0])

          // console.log(json,'json')
        })
        this.loading1 = false
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 新增或更新已设置字段表头-导出
    saveOrUpdateOrRemoveDC (list) {
      saveOrUpdateOrRemoveExport(list).then(res => {
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('refresh')
        this.$emit('update:tableMark', false)
      })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 确定
    confirm () {
      const selectData = this.$refs.tableList.selection
      if (selectData.length > 0) {
        this.settingData.forEach((item, index) => {
          this.$set(item, 'sort', index + 1)
          this.$set(item, 'tagCode', this.groupCode)
        })
        // id 新增没有，修改有，第二个接口查询所得
        // tagCode 分组编码： 订单列表-> orderPage 运单列表-> wayPage 收支列表-> szPage
        // dynamicFieldId 第一个接口返回的ID
        // isSettingQuery 是否作为查询条件 0. 否， 1 是
        // sort 排序顺序（越小越靠前）
        // console.log(this.settingData,'this.settingData')
        if (this.activeName == 'biaotou') {
          this.saveOrUpdateOrRemove(this.settingData)
        } else if (this.activeName == 'daochu') {
          this.saveOrUpdateOrRemoveDC(this.settingData)
        }
      } else {
        this.$alert('请至少选择一条数据进行操作', '系统提示')
      }
    },
    closeDialog () {
      this.tableList = []
      this.$emit('update:tableMark', false)
    }
  },
  beforeDestroy () {}
}
</script>

<style scoped lang='less'>
.t_body {
  padding-left: 5px;
}
.el-scrollbar__wrap {
  overflow-x: hidden;
}
.current-row{
  color: #409eff;
}
</style>
